/* Repair the terms app's label association when it inserts or rebuilds a cart. */
(() => {
  function repairPolicyLabel() {
    document.querySelectorAll('input[id="effectiveAppsAgreeCB"]').forEach((checkbox) => {
      const label = checkbox.parentElement.querySelector('label');
      if (!label || (label.htmlFor !== 'agree' && label.htmlFor !== checkbox.id)) return;
      if (label.htmlFor !== checkbox.id) label.htmlFor = checkbox.id;
    });
  }

  function repairRequestHeadings() {
    if (window.location.pathname !== '/pages/fragrance-request') return;
    let headingIndex = 0;
    document.querySelectorAll('main h4').forEach((heading) => {
      // Preserve the merchant's visual styling while supplying heading structure.
      if (!heading.textContent.trim()) {
        heading.setAttribute('role', 'presentation');
        return;
      }
      heading.setAttribute('role', 'heading');
      heading.setAttribute('aria-level', headingIndex++ === 0 ? '1' : '2');
    });
  }

  function initialize() {
    repairPolicyLabel();
    repairRequestHeadings();
    const observer = new MutationObserver(repairPolicyLabel);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['id', 'for']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
